<!--
 * @Description: 展示饼图
 * @Date: 2020-07-22 17:16:43
 * @Author: jawnwa22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-08-28 16:48:41
--> 
<template>
  <div class="display-pie-container" :style="{'height': graph.height + 'px'}">
    <div class="pie-header" :style="{'fontSize': graph.fontSize + 'px'}">
      <div
        class="pie-title__text"
        v-if="graph.showTitle"
        :style="{'color': graph.color}"
      >{{ graph.title }}</div>
      <div class="spacer"></div>

      <!-- <a :href="graph.link" target="_blank" class="pie-link__text" v-if="graph.showLink">
        {{ graph.linkText }}
        <img src="@/assets/images/icon_link.png" />
      </a>-->
    </div>
    <div class="pie-content" v-if="!nodata" :style="{'height': graph.height + 'px'}">
      <ve-pie height="100%" v-bind="$attrs"></ve-pie>
    </div>
    <div class="pie-content" v-else>
      <no-data tip="empty"></no-data>
    </div>
  </div>
</template>

<script>
import noData from '@/components/common/noData.vue';
export default {
  components: {
    noData,
  },
  props: {
    graph: {
      type: Object,
      default: () => {},
    },
    nodata: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/mixin';

.display-pie-container {
  //   position: relative;
  //   width: 100%;
  height: 100%;
  background-color: #f7fafd;
  border-radius: 8px;
  box-shadow: 0px 3px 12px 0px rgba(90, 111, 190, 0.8);
  padding: 10px 15px;
  box-sizing: border-box;

  .pie-header {
    // width: 100%;
    // // position: absolute;
    // top: 0;
    // padding: 10px;
    // display: flex;
    // align-items: center;
    // .pie-link__text {
    //   color: #004ec0;
    //   //   display: flex;
    //   align-items: center;
    // }
  }
  .pie-content {
    height: 100%;
  }
}
</style>